import I18N from 'assets/i18n/brandlift-project';

import {QuestionBankItem} from './types';
import {SurveyPreset} from 'client/common/types/survey';

const i18n = I18N.common.questionBank;

export const YANDEX_TEMPLATES = [
    SurveyPreset.YandexAdScriptTest,
    SurveyPreset.YandexAdStoryboardTest,
    SurveyPreset.YandexAdVideoTest,
    SurveyPreset.YandexNameTest,
    SurveyPreset.YandexConceptTest,
    SurveyPreset.YandexInterfaceMindfulness,
    SurveyPreset.YandexSerpSurvey,
    SurveyPreset.YandexActiveFeedback,
    SurveyPreset.YandexPassiveFeedback,
    SurveyPreset.YandexMorda
];

/* eslint-disable max-len */

export const items: QuestionBankItem[] = [
    {
        id: 1,
        initial: [SurveyPreset.SimpleProductConceptTesting],
        hidden: false,
        config: {
            label: i18n.acquire
        }
    },
    {
        id: 2,
        initial: [
            SurveyPreset.SimpleMarketAnalysis,
            SurveyPreset.SimplePriceSensitivityMeter,
            SurveyPreset.SimpleProductConceptTesting
        ],
        hidden: false,
        config: {
            label: i18n.use
        }
    },
    {
        id: 3,
        initial: [SurveyPreset.SimpleMarketAnalysis, SurveyPreset.SimpleProductConceptTesting],
        hidden: false,
        config: {
            label: i18n.howOften
        }
    },
    {
        id: 4,
        initial: [SurveyPreset.SimpleCustomerAnalytics, SurveyPreset.SimpleProductConceptTesting],
        hidden: false,
        config: {
            label: i18n.rateHowRelevant
        }
    },
    {
        id: 5,
        initial: [SurveyPreset.SimpleCompetitorAnalysis],
        hidden: false,
        config: {
            label: i18n.productsAndServicesYouKnow
        }
    },
    {
        id: 6,
        initial: [],
        hidden: false,
        config: {
            label: i18n.whenConsume
        }
    },
    {
        id: 7,
        initial: [SurveyPreset.SimpleCustomerAnalytics],
        hidden: false,
        config: {
            label: i18n.whenUse
        }
    },
    {
        id: 8,
        initial: [SurveyPreset.SimplePriceSensitivityMeter],
        hidden: false,
        config: {
            label: i18n.importantForChoose
        }
    },
    {
        id: 9,
        initial: [SurveyPreset.SimpleMarketAnalysis],
        hidden: false,
        config: {
            label: i18n.optimalPrice
        }
    },
    {
        id: 10,
        initial: [],
        hidden: false,
        config: {
            label: i18n.thoughtAbout
        }
    },
    {
        id: 11,
        initial: [],
        hidden: false,
        config: {
            label: i18n.knowAbout
        }
    },
    {
        id: 12,
        initial: [SurveyPreset.SimpleMarketAnalysis],
        hidden: false,
        config: {
            label: i18n.rateHowMuch
        }
    },
    {
        id: 13,
        initial: [],
        hidden: false,
        config: {
            label: i18n.whichPrefer
        }
    },
    {
        id: 14,
        initial: [],
        hidden: false,
        config: {
            label: i18n.howDoYou
        }
    },
    {
        id: 15,
        initial: [],
        hidden: false,
        config: {
            label: i18n.whichBrandsUseFor
        }
    },
    {
        id: 16,
        initial: [],
        hidden: false,
        config: {
            label: i18n.valueMostAboutBrandYouUse
        }
    },
    {
        id: 17,
        initial: [],
        hidden: false,
        config: {
            label: i18n.motivateUseAnotherBrand
        }
    },
    {
        id: 18,
        initial: [SurveyPreset.SimpleCompetitorAnalysis],
        hidden: false,
        config: {
            label: i18n.bestDealFor
        }
    },
    {
        id: 19,
        initial: [SurveyPreset.SimpleCompetitorAnalysis],
        hidden: false,
        config: {
            label: i18n.bestBrandPrice
        }
    },
    {
        id: 20,
        initial: [],
        hidden: false,
        config: {
            label: i18n.brandsWidestReachBestLocation
        }
    },
    {
        id: 21,
        initial: [SurveyPreset.SimpleCompetitorAnalysis],
        hidden: false,
        config: {
            label: i18n.brandsMostComfortable
        }
    },
    {
        id: 22,
        initial: [],
        hidden: false,
        config: {
            label: i18n.brandsWidestRange
        }
    },
    {
        id: 23,
        initial: [],
        hidden: false,
        config: {
            label: i18n.brandsBestQuality
        }
    },
    {
        id: 24,
        initial: [],
        hidden: false,
        config: {
            label: i18n.brandsMostReliable
        }
    },
    {
        id: 25,
        initial: [],
        hidden: false,
        config: {
            label: i18n.brandsBestLoyaltyProgram
        }
    },
    {
        id: 26,
        initial: [],
        hidden: false,
        config: {
            label: i18n.brandsSafeDeal
        }
    },
    {
        id: 27,
        initial: [],
        hidden: false,
        config: {
            label: i18n.buyFor
        }
    },
    {
        id: 28,
        initial: [SurveyPreset.SimplePriceSensitivityMeter],
        hidden: false,
        config: {
            label: i18n.priceMostBeneficial
        }
    },
    {
        id: 29,
        initial: [],
        hidden: false,
        config: {
            label: i18n.priceSeemHighButPay
        }
    },
    {
        id: 30,
        initial: [],
        hidden: false,
        config: {
            label: i18n.priceRefusePay
        }
    },
    {
        id: 31,
        initial: [SurveyPreset.SimplePriceSensitivityMeter],
        hidden: false,
        config: {
            label: i18n.priceQuestionQuality
        }
    },
    {
        id: 32,
        initial: [],
        hidden: false,
        config: {
            label: i18n.priceAtMoment
        }
    },
    {
        id: 33,
        initial: [],
        hidden: false,
        config: {
            label: i18n.priceImporantPurchase
        }
    },
    {
        id: 34,
        initial: [SurveyPreset.SimpleCustomerAnalytics],
        hidden: false,
        config: {
            label: i18n.priceImportantChoose
        }
    },
    {
        id: 35,
        initial: [],
        hidden: false,
        config: {
            label: i18n.motivateGiveUp
        }
    },
    {
        id: 36,
        initial: [],
        hidden: false,
        config: {
            label: i18n.motivateBigPrice
        }
    },
    {
        id: 37,
        initial: [SurveyPreset.SimpleCustomerAnalytics],
        hidden: false,
        config: {
            label: i18n.useOnline
        }
    },
    {
        id: 38,
        initial: [SurveyPreset.SimpleNameTesting],
        hidden: false,
        config: {
            label: i18n.associationsWhenHear
        }
    },
    {
        id: 39,
        initial: [SurveyPreset.SimpleNameTesting],
        hidden: false,
        config: {
            label: i18n.associationsPositiveOrNegative
        }
    },
    {
        id: 40,
        initial: [SurveyPreset.SimpleNameTesting],
        hidden: false,
        config: {
            label: i18n.namingForWhat
        }
    },
    {
        id: 41,
        initial: [SurveyPreset.SimpleNameTesting],
        hidden: false,
        config: {
            label: i18n.namingUnique
        }
    },
    {
        id: 42,
        initial: [],
        hidden: false,
        config: {
            label: i18n.namingEasyToRemember
        }
    },
    {
        id: 43,
        initial: [],
        hidden: false,
        config: {
            label: i18n.namingMotivateToUse
        }
    },
    {
        id: 44,
        initial: [],
        hidden: false,
        config: {
            label: i18n.namingAppropriate
        }
    },
    {
        id: 45,
        initial: [],
        hidden: false,
        config: {
            label: i18n.namingMostAppropriate
        }
    },
    {
        id: 46,
        initial: [],
        hidden: false,
        config: {
            label: i18n.namingLikeBetter
        }
    },
    {
        id: 47,
        initial: [],
        hidden: false,
        config: {
            label: i18n.namingMotivateToTry
        }
    },
    {
        id: 48,
        initial: [],
        hidden: false,
        config: {
            label: i18n.namingBestFitsDefinition
        }
    },
    {
        id: 49,
        initial: [SurveyPreset.SimpleDesignEvaluation],
        hidden: false,
        config: {
            label: i18n.logoHowMuchDoYouLike
        }
    },
    {
        id: 50,
        initial: [SurveyPreset.SimpleDesignEvaluation],
        hidden: false,
        config: {
            label: i18n.logoHowMemorable
        }
    },
    {
        id: 51,
        initial: [SurveyPreset.SimpleDesignEvaluation],
        hidden: false,
        config: {
            label: i18n.logoAssociatedWith
        }
    },
    {
        id: 52,
        initial: [SurveyPreset.SimpleDesignEvaluation],
        hidden: false,
        config: {
            label: i18n.logoRightForYou
        }
    },
    {
        id: 53,
        initial: [],
        hidden: false,
        config: {
            label: i18n.logoMostImportant
        }
    },
    {
        id: 54,
        initial: [],
        hidden: false,
        config: {
            label: i18n.logoAppropriate
        }
    },
    {
        id: 55,
        initial: [],
        hidden: false,
        config: {
            label: i18n.logoWhichProduct
        }
    },
    {
        id: 56,
        initial: [],
        hidden: false,
        config: {
            label: i18n.logoUnique
        }
    },
    {
        id: 57,
        initial: [],
        hidden: false,
        config: {
            label: i18n.logoWhichMostAppropriate
        }
    },
    {
        id: 58,
        initial: [],
        hidden: false,
        config: {
            label: i18n.logoLikeMost
        }
    },
    {
        id: 59,
        initial: [],
        hidden: false,
        config: {
            label: i18n.logoIntentToTry
        }
    },
    {
        id: 60,
        initial: [],
        hidden: false,
        config: {
            label: i18n.logoBestFitsDefinition
        }
    }
];
